import { Pipe, PipeTransform } from '@angular/core';
import { isWithinInterval, startOfDay, endOfDay, isBefore } from 'date-fns';

@Pipe({
    name: 'isDateInRange',
    standalone: false
})
export class IsDateInRangePipe implements PipeTransform {

  constructor() {

  }

  transform(dateToCompare: Date | string, from: Date = new Date(), to: Date = new Date()): number {
    return isWithinInterval(new Date(dateToCompare), { start: startOfDay(from), end: endOfDay(to) }) ? 0 : isBefore(new Date(dateToCompare), startOfDay(from)) ? -1 : 1;
  }
}
